import SimplePopUp from '../../lib/SimplePopUp/SimplePopUp';
import { getCookieConfig } from './CookieConfigBuilder';
import {
  isEmpty,
  ProjectTypes,
  getProjectType,
} from '@r-and-a-shared-ui/utils';
import { useContext, useEffect, useState } from 'react';
import classnames from 'classnames';
import { Link } from '../Link/Link';
import { CookiePopupProps, CookieSettingsProps } from './CookiesTypes';
import { EnvironmentContext } from '../../contexts';

import stylesPP from './scss/CookiesPopupPP.module.scss';
import stylesMMB from './scss/CookiesPopupMMB.module.scss';

export interface CustomWindow extends Window {
  CookieControl: any;
}
declare let window: CustomWindow;

export const loadCookiesConfig = (cookiesSettings: any) => {
  if (isEmpty(cookiesSettings) || cookiesSettings.isEmpty) {
    return;
  }

  const config = getCookieConfig(cookiesSettings);

  if (isEmpty(window?.CookieControl) || isEmpty(config)) {
    return;
  }

  window.CookieControl.load(config);
};

export function CookiesPopup({
  cookiesPopup,
  cookiesSettings,
}: {
  cookiesPopup: CookiePopupProps;
  cookiesSettings: CookieSettingsProps;
}) {
  const { Image } = useContext(EnvironmentContext);
  const isCookiePopupEnabled =
    process.env.NEXT_PUBLIC_COOKIES_POPUP?.toLowerCase() !== 'false';
  const [showCookiePopUp, setShowCookiePopUp] = useState(false);

  const isPPproject = getProjectType() === ProjectTypes.PlayerPortals;
  const styles = isPPproject ? stylesPP : stylesMMB;

  useEffect(() => {
    loadCookiesConfig(cookiesSettings);
  }, [cookiesSettings]);

  useEffect(() => {
    if (!window.CookieControl) {
      return;
    }

    loadCookiesConfig(cookiesSettings);

    const cookieControl = window.CookieControl?.getCookie('CookieControl');
    setShowCookiePopUp(isEmpty(cookieControl));
  }, []);

  const handleAcceptAllCookiesClick = (event: any) => {
    event.preventDefault();
    setShowCookiePopUp(false);
    window.CookieControl.acceptAll();
  };

  const handleSettingsClick = (event: any) => {
    event.preventDefault();

    setShowCookiePopUp(false);
    window.CookieControl.open();
  };

  const handleClose = () => {
    setShowCookiePopUp(false);
  };

  if (
    !isCookiePopupEnabled ||
    isEmpty(cookiesSettings) ||
    isEmpty(cookiesPopup)
  ) {
    return null;
  }

  return (
    <div className={styles.popup}>
      <SimplePopUp isVisible={showCookiePopUp} onClose={handleClose}>
        <div className={styles.content}>
          {cookiesPopup?.logoImage && (
            <div className={styles.logo}>
              <Image alt="Logo" src={cookiesPopup?.logoImage} fill />
            </div>
          )}
          {cookiesPopup?.title && (
            <h3 className={styles.title}>{cookiesPopup?.title}</h3>
          )}
          {cookiesPopup?.description && (
            <div className={styles.copy}>{cookiesPopup?.description}</div>
          )}
          {cookiesPopup?.buttonLabel && (
            <div
              onClick={handleAcceptAllCookiesClick}
              className={classnames(styles.btn, styles['btn--primary'])}
              role="button"
              aria-label="Accept all cookies"
              tabIndex={0}
            >
              {cookiesPopup?.buttonLabel}
            </div>
          )}
          <div className={styles.subscription}>
            {cookiesPopup?.detailsSubtext && (
              <span className={styles.subscription__copy}>
                {cookiesPopup?.detailsSubtext}
              </span>
            )}
            {cookiesPopup?.detailsSubscription && (
              <span
                className={styles.link}
                onClick={handleSettingsClick}
                role="button"
                aria-label="Cookies settings"
                tabIndex={0}
              >
                {cookiesPopup?.detailsSubscription}
              </span>
            )}
          </div>
          <div className={styles.privacy}>
            {cookiesPopup?.cookiesPageLink && (
              <Link
                className={styles.link}
                {...cookiesPopup?.cookiesPageLink}
                openInNewTab={true}
              >
                {cookiesPopup?.cookiesPageLink?.title}
              </Link>
            )}
          </div>
        </div>
      </SimplePopUp>
    </div>
  );
}
export default CookiesPopup;
